import Vue from "vue";
// http://localhost:8081/baseIP/BimModel/projectGisInfo?projectId=255513056948293
import {
  getLoginUser,
  getProjectGisInfo,
  getPlotItemGroupListService,
  getProjectBimModel,
  getProjectKmlAndShpInfo,
} from "../../api/api.js";
import initPlatformSettings from "@/components/tables/basicSettings/config/index.js";
// 使用免费开源版本
// import 'mars3d/dist/mars3d.css'
// import * as mars3d from 'mars3d'

// 使用交付版本
// import './lib/mars3d.css'
// import * as mars3d from './lib/mars3d'
// import * as BimMap from "@/views/index/zhang.js";
import { BimMap } from "chbim";
// import PanoramicView from "@/mapUtils/PanoramicView.js";
// console.log("PanoramicView", PanoramicView);
const mars3d = window.mars3d;
// console.log("zhang", BimMap);

// 为了方便使用,绑定到原型链，在其他vue文件，直接 this.mars3d 来使用
Vue.prototype.mars3d = window.mars3d;
Vue.prototype.Cesium = mars3d.Cesium;

export default {
  name: "mars3dViewer",

  props: {
    // 初始化配置参数
    url: String,
    widgetUrl: String,

    // 地图唯一性标识
    mapKey: {
      type: String,
      default: "",
    },

    // 自定义参数
    options: Object,

    // 是否分屏显示
    compare: {
      type: Boolean,
      default: false,
    },

    // 是否插入到body元素上
    appendToBody: {
      type: Boolean,
      default: false,
    },

    // 自定义css类名
    customClass: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      mapParameter: null,
    };
  },
  mounted() {
    if (this.appendToBody) {
      document.body.appendChild(this.$el);
    }
    this.loadingMap();
  },

  destroyed() {
    if (mars3d?.widget?.destroy && mars3d.widget.destroy instanceof Function) {
      mars3d.widget.destroy();
    }
    if (
      this.$GLOBAL.map?.destroy &&
      this.$GLOBAL.map.destroy instanceof Function
    ) {
      try {
        this.$GLOBAL.map.destroy();
      } catch (e) {
        console.log(e);
      }
    }
    this.$GLOBAL.map = null;
    console.log("销毁", this.$GLOBAL);
  },

  methods: {
    async loadingMap() {
      //window.sessionStorage.clear();
      // 先发起一次请求，好获取到正确的token是否过期的值。
      await getLoginUser({
        appType: 1,
      }).then();
      // 检测一下token是否过期，如果已过期则不加载地图。
      const tokenExpired = window.sessionStorage.getItem("tokenExpired");
      if (tokenExpired !== "true") {
        if (this.mapKey) {
          this.initMars3d(this.options);
        } else {
          this.getMapBasicResources(this.url);
          // mars3d.Resource.fetchJson({
          //   url: this.url,
          // }).then((data) => {
          //   this.initMars3d(data.map3d); // 构建地图
          // });
        }
      }
    },

    // npm 初始化
    getMapBasicResources(url) {
      let { indexProjectString } = this.$route.params;
      let mapObj = new Map([
        [
          "gis_environment_url",
          process.env.VUE_APP_PROJECT_BASE_URL +
            process.env.VUE_APP_DEM_BASE_PORT,
        ],
        [
          "gis_xyzLayer_url",
          process.env.VUE_APP_PROJECT_BASE_URL +
            process.env.VUE_APP_DOM_BASE_PORT,
        ],
        [
          "model_url",
          process.env.VUE_APP_PROJECT_BASE_URL +
            process.env.VUE_APP_MODEL_BASE_PORT,
        ],
      ]);
      let projectId = window.sessionStorage.getItem("nowProjectId");

      let getProjectGisInfoFn = new Promise((resolve, reject) => {
        getProjectGisInfo({
          projectId,
        })
          .then((res) => {
            let { code, data } = res.data;
            console.log("npm获取地图数据影像", code, data);
            mapObj.set("gis", data);
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });

      let getPlotItemGroupListServiceFn = new Promise((resolve, reject) => {
        getPlotItemGroupListService({
          projectId,
          DataType: 1,
        })
          .then((res) => {
            let { code, data } = res.data;
            console.log("npm获取地图标绘数据", code, data);
            mapObj.set("plotting", data);
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });

      let getProjectBimModelFn = new Promise((resolve, reject) => {
        getProjectBimModel({
          projectId,
          CategoryName: "子分项工程",
        })
          .then((res) => {
            let { code, data } = res.data;
            console.log("npm获取地图模型数据", code, data);
            mapObj.set("model", data);
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });

      let getProjectKmlAndShpInfoFn = new Promise((resolve, reject) => {
        getProjectKmlAndShpInfo({
          projectId,
        })
          .then((res) => {
            let { code, data } = res.data;
            console.log("npm获取kml shp数据", code, data);
            mapObj.set("kmlAndShp", data);
            resolve(data);
          })
          .catch((err) => {
            reject(err);
          });
      });

      Promise.all([
        getProjectGisInfoFn,
        getPlotItemGroupListServiceFn,
        getProjectBimModelFn,
        getProjectKmlAndShpInfoFn,
      ])
        .then((res) => {
          mapInst();
        })
        .catch((err) => {
          mapInst();
        });

      let mapInst = () => {
        const callback = new Map([
          ["gis", this.gisFn],
          ["model", this.modelFn],
          ["kmlAndShp", this.kmlAndShpFn],
        ]);

        this.mapParameter = mapObj;

        this.$GLOBAL.brightnessEffect = new mars3d.effect.BrightnessEffect({
          brightness: 1.5,
        });

        BimMap.mapInst(url, indexProjectString).then((map) => {
          this.$GLOBAL.map = map;
          // 添加光照效果
          this.$GLOBAL.map.addEffect(this.$GLOBAL.brightnessEffect);
          // 地图报错
          map.on(mars3d.EventType.renderError, (event) => {
            this.$message({
              message:
                "当前系统运行出现异常，可能是勾选的模型过多导致的，请刷新当前页面~",
              type: "warning",
              offset: 100,
              showClose: true,
              duration: 3600,
            });
          });
          this.$emit("onload", this.$GLOBAL.map, mapObj);
          if (this.$route.params.stype.indexOf("program") > -1) {
            ["gis"].forEach((item) => {
              BimMap.loadResources(mapObj, item, callback.get(item));
            });
          } else {
            ["gis", "model", "kmlAndShp"].forEach((item) => {
              BimMap.loadResources(mapObj, item, callback.get(item));
            });
          }
          initPlatformSettings();

          panoramicView.on("type", (e) => {
            if (e.type == "success") {
              this.$notify({
                title: "截图完成，请下载压缩包",
                message: "",
                type: "success",
                duration: 960,
                offset: 320,
              });
            } else {
              this.$notify({
                title: "截图失败",
                message: "",
                type: "error",
                duration: 960,
                offset: 320,
              });
            }
          });
        });
      };
    },
    // initPlatformSettings()
    initPlatformSettings: _.debounce(function () {
      // console.log("加载完成gis2");
      initPlatformSettings();
    }, 800),
    // 初始化加载gis后的回调
    gisFn(e) {
      console.log("加载完成gis", e);
      this.$GLOBAL.tileLayerIds.push(e.layer.id);
      this.initPlatformSettings();
    },
    // 初始化加载模型后的回调
    modelFn(e) {
      console.log("加载完成model", e);
    },
    // 初始化加载矢量后的回调
    kmlAndShpFn() {},

    initMars3d(options) {
      //if (this[`map${this.mapKey}`]) return
      const mapOptions = {
        ...options,
        ...this.options,
      };
      this.$GLOBAL.brightnessEffect = new mars3d.effect.BrightnessEffect(); //mapOptions.effect;
      // 创建三维地球场景
      //var map = new mars3d.Map(`mars3d-container${this.mapKey}`, mapOptions)
      this.$GLOBAL.map = new mars3d.Map(
        `mars3d-container${this.mapKey}`,
        mapOptions
      );
      // this[`map${this.mapKey}`] = map

      //获取右键菜单选项，去掉不需要的。
      //先解绑map默认自带的右键菜单。
      this.$GLOBAL.map.unbindContextMenu();
      let defaultContextmenuItems = this.$GLOBAL.map.getDefaultContextMenu();
      console.log("反键", defaultContextmenuItems);
      //可以删减defaultContextmenuItems数组内值。这里只保留数组序列号【从0开始】第2、3序号项。
      let setMenuItems = [];
      [0, 2, 3, 5].map(function (item) {
        if (defaultContextmenuItems[item]) {
          setMenuItems.push(defaultContextmenuItems[item]);
        }
      });

      if (setMenuItems && setMenuItems.length > 0) {
        this.$GLOBAL.map.bindContextMenu(setMenuItems);
      } else {
        this.$GLOBAL.map.bindContextMenu(defaultContextmenuItems);
      }
      //添加光照效果
      this.$GLOBAL.map.addEffect(this.$GLOBAL.brightnessEffect);

      console.log(">>>>> 地图创建成功 >>>>", this.$GLOBAL.map);
      console.log(this.mapKey);

      // 抛出事件
      this.$emit("onload", this.$GLOBAL.map);
    },
  },
};
